const menu = {
    label: '• Contratação de Credenciado',
    to: '/sol/contratacaocredenciado',
    rules: ['SOL-001'],
};

export default menu;
